import { useState } from 'react';
import { request } from '../request';
import fileDownloader from './fileDownloader';
const useFileDownloader = () => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [error, setError] = useState();
    const downloadFile = async ({ domain, url, fileName }) => {
        setIsDownloading(true);
        try {
            const fileUrl = await request('GET', domain, url)
                .then(res => res.blob())
                .then(blob => window.URL.createObjectURL(blob));
            fileDownloader(fileUrl, fileName);
            setIsDownloading(false);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(`ERROR: downloading file ${fileName}`, err);
            setIsDownloading(false);
            setError(err);
        }
    };
    return { downloadFile, isDownloading, error };
};
export default useFileDownloader;
//# sourceMappingURL=useFileDownloader.js.map